export const LOAD_TYPE = 'lumahealth/FieldContactTypeAutodetect/LOAD_TYPE';
export const LOAD_TYPE_SUCCESS = 'lumahealth/FieldContactTypeAutodetect/LOAD_TYPE_SUCCESS';
